import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChange } from '@angular/core';
// import { d4dbService  } from '../../services/d4db.service';

import * as d3 from 'd3';
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;
// import * as dbox from '@dboxjs/core';
declare var dbox: any
import * as _ from 'lodash';

@Component({
  selector: 'dbox-bars',
  templateUrl: './dboxBars.component.html',
  styleUrls: ['./dboxBars.component.scss']
})
export class DboxBarsComponent implements OnInit, OnChanges {
  @Input() colors;
  @Input() topic;
  @Input() selectedOne;
  @Input() selectedTwo;
  @Input() hover;
  @Input() unhover;
  @Output() onClick = new EventEmitter();
  @Output() onHover = new EventEmitter();
  @Output() onHoverOut = new EventEmitter();

  chart;

  /** ngOnInit: Init component, gets municipality data and stores it on chartData,
   * gets data from escuelas_localidad.csv and stores it in mun_localities
   * then draws Localities Scatter
   * @since v2
  */
  ngOnInit() {
    this.draw()
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    for (const propName of Object.keys(changes)) {
      const changedProp = changes[propName];
      const to = JSON.parse(JSON.stringify(changedProp.currentValue));
      if (changedProp.isFirstChange()) {
        // console.log(`Initial value of ${propName} set to ${to}`);
        // this.draw()
      } else {
        const from = JSON.stringify(changedProp.previousValue);
        // console.log(`${propName} changed from ${from} to ${to}`);
        if (propName === 'colors') {
          this.draw()
        }
        if (propName === 'selectedOne' && to !== null && to.by !== 'bars') {
          this.select(to);
        }
        if (propName === 'selectedTwo' && to !== null && to.by !== 'bars') {
          this.select(to);
        }
        if (propName === 'hover' && to !== null && to.by !== 'bars') {
          this.select(to);
        }
        if (propName === 'unhover' && to !== null  && to.by !== 'bars') {
          this.unselect(to);
        }
      }
    }
  }

  draw() {
    const vm = this;
    const width = $('#bars').width(); // Getting scatter container size
    const format = d3.format('.0f');
    const config = {
      'size': {
        'width': width,
        'height': 120,
        'margin': {top: 5, right: 0, bottom: 65, left: 0}
      },
      'xAxis': {
        'enabled': true,
        'scale': 'ordinal',
        'line': {
          'enabled': false,
        },
        'ticks': {
          'enabled': true,
          'style': {
            'fill': '#6E6E6E',
            'font-family': '"Lato", sans-serif',
            'font-size': '11px',
          },
          'format': function(d, i){
            const index = i + 1
            return d + ' - '  + index;
          },
          'x': '-.5em',
          'y': '-.5em',
          'rotate': -90,
          'line': {
            enabled: false
          }
        }
      },
      'yAxis': {
        'enabled': false,
        'scale': 'linear',
      },
      'bars': {
        'quantiles': {
          'buckets': 5,
          'colors': vm.colors.default,
          'colorsOnHover': vm.colors.onHover,
          'ignoreZeros' : false
        }
      },
      'data': {
        'onclick': function(d, i){
          const bars = vm.chart.layers[0]

          d3.selectAll('.stip').remove();

          // Set the onHover color
          if (d.CVE_ENT === '33') {
          } else {
            d3.select('#bars #bars-' + d.CVE_ENT).attr('fill', function(o) {
              if (bars._config.bars.quantiles.colorsOnHover) { // OnHover colors
                return bars._getQuantileColor(o[bars._config.color], 'onHover');
              }
            })

            vm.onClick.emit({d, i});
          }
          //Waiting for chart to redraw and place tooltips
          setTimeout(function(){
            //Looping through all bar and selecting the ones with color to show tooltip
            d3.select('#bars svg').selectAll('.bar').each(function(d,i){

              var color = d3.select(this).attr('fill');
              if(d3.select(this).attr('fill') === "#e2e2ed" || d3.select(this).attr('fill') === "#c8c8d4" || d3.select(this).attr('fill') === '#aeaebb' || d3.select(this).attr('fill') === '#9494a2' || d3.select(this).attr('fill') === '#7a7a89'){
                d3.selectAll('.state-tip-'+d['CVE_ENT']).remove()
              }
              else if(i !== 32){ //32 is for National, its tootip is defined on Map component
                var stateTip = d3Tip().attr('class', 'stip state-tip-' + d['CVE_ENT']);

                var stateSelection = vm.selectedTopic(d);
                
                stateTip.html(function(){
                  return stateSelection;
                });
                
                d3.select('#bars svg').call(stateTip); 
                var stateBar = d3.select('#bars #bars-' + d['CVE_ENT']);
                
                stateBar.each(function(d){
                  stateTip.show(stateSelection, stateBar.node());
                });

                d3.select('.state-tip-' + d['CVE_ENT']).style('color', d3.select(this).attr('fill'));
              }
                
            });
          }, 300)

        },
        'onmouseover': function(d, i){
          // If Nacional, then - leave the same color
          if (d.CVE_ENT === '33') {
            d3.select('#bars #bars-33').attr('fill', '#00B7B7')
          } else {
            vm.onHover.emit({d, i});
          }
        },
        'onmouseout': function(d, i){
          const bars = vm.chart.layers[0]
          if (d.CVE_ENT === '33') { // if Nacional restore color
            d3.select('#bars #bars-33').attr('fill', '#00B7B7')
          } else {
            // If the bar is the same as the selected by the User, then - restore color
            if (vm.selectedOne !== null && vm.selectedOne.d.CVE_ENT === d.CVE_ENT) {
              d3.select('#bars #bars-' + d.CVE_ENT).attr('fill', function(o) {
                if (bars._config.bars.quantiles.colorsOnHover) { // OnHover colors
                  return bars._getQuantileColor(o[bars._config.color], 'onHover');
                }
              })
            }
            // If the bar is the same as the selected by the User, then - restore color
            if (vm.selectedTwo !== null && vm.selectedTwo.d.CVE_ENT === d.CVE_ENT) {
              d3.select('#bars #bars-' + d.CVE_ENT).attr('fill', function(o) {
                if (bars._config.bars.quantiles.colorsOnHover) { // OnHover colors
                  return bars._getQuantileColor(o[bars._config.color], 'onHover');
                }
              })
            }
          }
          vm.onHoverOut.emit({d, i});
        }
      },
      'events': {
        'load': function(c){
          const bars = c.layers[0];

          // Set the color of Nacional and show its tooltip
          d3.select('#bars #bars-33').attr('fill', '#00B7B7');

          // Set the ranking of the states without counting Nacional
          let counter = 0; 
          d3.selectAll('#bars .x.axis text')
            .style('fill', function(d) {
              if (d === 'NAC') {
                return '#1AB7B7';
              } else {
                return '#6e6e6e';
              }
            })
            .text(function(d, i){
              if (d === 'NAC') {
                return 'NACIONAL';
              } else {
                counter += 1;
              }
              return d + ' - ' + counter;
            })

          // If the bar is the same as the selected by the User, then - restore color
          if (vm.selectedOne !== null ) {
            d3.select('#bars #bars-' + vm.selectedOne.d.CVE_ENT).attr('fill', function(d) {
              if (bars._config.bars.quantiles.colorsOnHover) { // OnHover colors
                return bars._getQuantileColor(d[bars._config.color], 'onHover');
              }
            })
          }

          // If the bar is the same as the selected by the User, then - restore color
          if (vm.selectedTwo !== null) {
            d3.select('#bars #bars-' + vm.selectedTwo.d.CVE_ENT).attr('fill', function(d) {
              if (bars._config.bars.quantiles.colorsOnHover) { // OnHover colors
                return bars._getQuantileColor(d[bars._config.color], 'onHover');
              }
            })
          }

        }
      }
    };

    vm.chart = dbox.chart(config)
      .bindTo('#bars')
      .data({'csv': 'assets/data/coeficienteTAI.csv'})
      .layer(dbox.bars)
        .id('CVE_ENT')
        .x('ENT')
        .y(this.topic)
        .color(this.topic)
        .sortBy([this.topic])
      .end()
      .draw();
  }

  select(data) {
    // console.log('dboxBars.component - Selected by parent',data)
    // IF Nacional, do nothing
    if (data.d.CVE_ENT === '33') {
      return false;
    }

    const bars = this.chart.layers[0]
    bars._tip.hide()

    d3.select('#bars-' + data.d.CVE_ENT).attr('fill', function(d) {
      bars._tip.show(d, d3.select(this).node());
      if (bars._config.bars.quantiles.colorsOnHover) { // OnHover colors
        return bars._getQuantileColor(d[bars._config.color], 'onHover');
      }
    })
  }

  unselect(data) {
    // console.log('dboxBars.component - UnSelected by parent',data)
    const vm = this;
    const bars = this.chart.layers[0];
    // IF Nacional, then - Do nothing
    if (data.d.CVE_ENT === '33') {
      return false;
    }

    /** If there is a selectedOne, the selectedOne is the same as the houver out,
     * and the trigger is not a user click or dropdown selection, then -  Do noting
     */
    if (vm.selectedOne !== null && vm.selectedOne.d.CVE_ENT === data.d.CVE_ENT && data.by !== 'user') {
      /*d3.select('#bars-'+ data.d.CVE_ENT).each( function(d) {
        bars._tip.show(d, d3.select(this).node());
      })*/
      return false
    }

    /** If there is a selectedOne, the selectedOne is the same as the hover out,
     * and the trigger is not a user click or dropdown selection, then -  Do noting
     */
    if (vm.selectedTwo !== null && vm.selectedTwo.d.CVE_ENT === data.d.CVE_ENT && data.by !== 'user') {
      /*d3.select('#bars-'+ data.d.CVE_ENT).each( function(d) {
        bars._tip.show(d, d3.select(this).node());
      })*/
      return false
    }
    // If the user hovers out and it is not one of the selectedOne or selectedTwo, then -  Restore the default color
    d3.select('#bars-' + data.d.CVE_ENT).attr('fill', function(d) {
      bars._tip.hide()
      return bars._getQuantileColor(d[bars._config.color], 'default');
    });
  }

      /** selectedTopic: get variable selected from navbar in map
   * @returns {string} 
   * @since v2
  */
  selectedTopic(data){
    var actualClass = d3.select('.nav-extended .tabs-transparent .active').attr('class');
    var actual = actualClass.split(" ");

    var format = d3.format('.2f');

    switch(actual[0]){
      case 'coeficiente_TAI':
        return format(data.coeficiente_TAI);
      case 'corrupcion':
        return format(data.corrupcion);
      case 'impunidad':
        return format(data.impunidad);
      case 'opacidad':
        return format(data.opacidad);
    }
  }
}



// WEBPACK FOOTER //
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxBars/dboxBars.component.ts